import styled from 'styled-components';

/* cards */
export const CardContainer = styled.div`
    padding: 24px;
    border-radius: 12px;
    border: 1px solid ${(props) => props.theme.grey_28_tr};
    cursor: ${(props) => (props.$isHoverable ? 'pointer' : null)};
`;
export const DiskBadgeWrapper = styled.div`
    margin-right: 16px;
`;

/* Banner */
export const BannerContainer = styled.a`
    background: ${(props) => props.theme.oceanBlue_1};
    position: relative;
    border-radius: 12px;
    padding: 24px 16px 16px 16px;
    width: 100%;
    max-width: 504px;
    box-sizing: border-box;
    display: flex;
    align-items: end;
    justify-content: space-between;
    cursor: pointer;
`;
export const BannerCloseButton = styled.span`
    position: absolute;
    top: 8px;
    right: 8px;
`;
export const BannerSubtitle = styled.div`
    max-width: 330px;
`;
